import React, { FC } from 'react';
import { Container } from 'react-bootstrap';

import '../../styles/app.scss';
import * as styles from './PageBanner.module.scss';

interface PageBannerProps {
  title: string;
  subtitle: string;
}

const PageBanner: FC<PageBannerProps> = ({ title, subtitle }) => {
  return (
    <div className={styles.banner}>
      <Container>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </Container>
    </div>
  );
};

export default PageBanner;